import FieldContainer from 'components/creditCard/Form/components/FieldContainer/styled';

export default FieldContainer;
